/** Poster — document knowledge definition. Pure data. */
export default {
  id: 'poster',
  name: 'Poster',
  description: 'A large-format piece designed to be read at a distance and remembered.',
  purpose: 'Announcement & Awareness',
  recommendedSizes: [
    { name: 'A3', width: 3508, height: 4961, unit: 'px' },
    { name: 'A2', width: 4961, height: 7016, unit: 'px' },
  ],
  supportedOrientations: ['portrait', 'landscape'],
  supportsMultiplePages: false,
  supportsBleed: true,
  supportsImages: true,
  supportsIcons: true,
  supportsQR: true,
  supportsTables: false,
  supportsPricing: false,
  supportsCTA: true,
  supportsOffers: true,
  supportsTimeline: false,
  supportsGallery: false,
  typicalSections: ['Headline', 'Hero', 'Supporting Text', 'Callout', 'Footer'],
};
